<template>

<transition name="modal">
        <div class="modal-mask" v-if="show">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header">
               <h3> <slot name="header">
                </slot>
                   </h3>
              </div>
              <div class="modal-body">
                <slot name="body">
                     
                </slot>
              </div>
              <div class="modal-footer">
                <slot name="footer">
                    <div class="cf-simple-btn" style="display: inline-block; font-size: 14px;margin-right:30px;width:80px;text-align:center" v-on:click.prevent="$emit('ok')">
                        OK
                    </div>
                     <div v-show="showCancelButton" class="cf-simple-btn" style="display: inline-block; font-size: 14px;" v-on:click.prevent="$emit('cancel')">
                        キャンセル
                    </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
</template>

<script>
export default {
  name: "t-dialog",
  props: ["show"],
  watch: {
    show: function(val) {
      //What?:モーダル表示時、Bodyのスクロールを止めている
      //Why?:モーダル表示しても、Bodyのスクロールが効いていて、操作性が悪くなるのを防ぐ
      //Notice: index.htmlに直接modal-open-to-no-scrollを記述する必要あり。
      const el = document.body;
      if (val === true) {
        el.classList.add("modal-open-to-no-scroll");
        return;
      }
      el.classList.remove("modal-open-to-no-scroll");
    }
  },
  data() {
    return {
      showCancelButton: true
    };
  },
  computed: {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.cf-simple-btn {
  cursor: pointer;
  &:hover {
    color: #ff6600;
  }
}
//==============================
//spike:モーダル
//=============================
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  //min-width:200px;
  margin: auto auto;
  padding: 30px 30px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-header h3 {
  margin-top: 0;
  // color: #42b983;
  font-size: 14px;
  font-weight: bold;
  color: rgba(4, 159, 234, 1);
}
.modal-body {
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/TDialog.vue